import { render, staticRenderFns } from "./restaurantBox.vue?vue&type=template&id=3a7166fa&scoped=true"
import script from "./restaurantBox.vue?vue&type=script&lang=js"
export * from "./restaurantBox.vue?vue&type=script&lang=js"
import style0 from "./restaurantBox.vue?vue&type=style&index=0&id=3a7166fa&prod&scoped=true&lang=scss"
import style1 from "./restaurantBox.vue?vue&type=style&index=1&id=3a7166fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_css-loader@6.11.0_webpack@5.104.1_cssnano@5_665be98a8828166c9882e9000b2a540b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7166fa",
  null
  
)

export default component.exports